import { createSelector } from 'reselect';

const selectGlobalOBNAgents = (state: any) => state.globalOBNAgents;

export const selectGlobalOBNAgentsCurrentItem = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.current);

export const selectGlobalOBNAgentsListItems = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalOBNAgentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalOBNAgentsQueryItems = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.query);

export const selectGlobalOBNAgentsCreatedItem = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.create);

export const selectGlobalOBNAgentsUpdatedItem = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.update);

export const selectGlobalOBNAgentsReadItem = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.read);

export const selectGlobalOBNAgentsDeletedItem = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.delete);

export const selectGlobalOBNAgentsSearchedItems = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.search);

export const selectGlobalOBNAgentsItemsCount = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.count);

export const selectGlobalOBNAgentsItemsFilter = createSelector([selectGlobalOBNAgents], (globalOBNAgents) => globalOBNAgents.filter);